function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Loyalty Interface
 *    Scripts to control the Loyalty Lion interface shown 
 *    to customers after login.
 *
 *    Useful LL Objects:
 *      window.loyaltylion.program;
 *      window.loyaltylion.customer;
 * 
 *  Version:
 *    1.0.0 - 2020/05/21
 */

import $ from 'jquery';
import { Accordion } from '../objects/content/Accordion';

//Selectors
export var CONTAINER_SELECTOR = '[data-loyalty-interface]';
export var LOYALTY_PROGRESS_TIERS = '[data-loyalty-progress-tiers]';
export var LOYALTY_PROGRESS_TIER = '[data-loyalty-tier]';
export var LOYALTY_TIER_NUMBER = '[data-loyalty-tier-number]';
export var LOYALTY_TIER_TITLE = '[data-loyalty-tier-title]';
export var LOYALTY_CURRENT_COUNT = '[data-loyalty-current-count]';
export var LOYALTY_OFFSET = '[data-loyalty-offset]';
export var LOYALTY_NEXT_COUNT = '[data-loyalty-next-count]';
export var LOYALTY_NEXT_CONTAINER = '[data-loyalty-next-container]';
export var LOYALTY_PROGRESS_BAR = '[data-loyalty-progress-bar]';
export var LOYALTY_POINTS_TEXT = '.lion-rule-item__points';
export var LOYALTY_HISTORY_STATUS = '.lion-history-table__row-status';
export var LOYALTY_HISTORY_ROW_CELL = '.lion-history-table__row-cell';
export var LOYALTY_FAQ = '[data-loyalty-faq]';

//Attrs
export var LOYALTY_TIER_ID = 'data-tier-id';
export var LOYALTY_NAVIGATION = 'data-loyalty-navigation';
export var LOYALTY_TAB = 'data-loyalty-tab';
export var TREE_OFFSET = 0.307;

//Classes
export var CLASS_CURRENT = 'is-current';
export var CLASS_VISIBLE = 'is-visible';
export var CLASS_ACTIVE = 'is-active';
export var CLASS_CENTERED = 'is-centered';
export var CLASS_FINAL_TIER = 'is-final-tier';
var LoyaltyInterface = /*#__PURE__*/function () {
  function LoyaltyInterface(container) {
    var _this = this;
    _classCallCheck(this, LoyaltyInterface);
    this.container = container;
    this.progressTiers = container.find(LOYALTY_PROGRESS_TIERS);
    this.currentCount = container.find(LOYALTY_CURRENT_COUNT);
    this.offset = container.find(LOYALTY_OFFSET);
    this.nextCount = container.find(LOYALTY_NEXT_COUNT);
    this.nextContainer = container.find(LOYALTY_NEXT_CONTAINER);
    this.progressBar = container.find(LOYALTY_PROGRESS_BAR);
    this.navigationElements = container.find("[".concat(LOYALTY_NAVIGATION, "]"));
    this.tabs = container.find("[".concat(LOYALTY_TAB, "]"));

    //Loyalty FAQ Accordions
    this.faqAccordionEl = container.find(LOYALTY_FAQ);
    if (this.faqAccordionEl.length) this.faqAccordions = new Accordion(this.faqAccordionEl);

    //Check to see if LL has initialised
    this.loyaltyLionCheck = setInterval(function () {
      return _this.checkLoyaltyLion();
    }, 100);
    container.on('click touchend', "[".concat(LOYALTY_NAVIGATION, "]"), function (e) {
      return _this.onNavClick(e);
    });
  }
  _createClass(LoyaltyInterface, [{
    key: "checkLoyaltyLion",
    value: function checkLoyaltyLion() {
      // Do we have the required data from Loyalty Lion ready?
      if (!window.loyaltylion.customer) return;
      // clear the interval to stop the function from being called
      clearInterval(this.loyaltyLionCheck);
      this.currentTier = window.loyaltylion.customer.loyaltyTierMembership.loyaltyTierId;
      this.currentPoints = window.loyaltylion.customer.pointsApproved;

      //Initialised, now start making or changes
      this.populateTiers();
      this.updateTextValues();
    }
  }, {
    key: "populateTiers",
    value: function populateTiers() {
      var _this2 = this;
      var tiers = loyaltylion.program.loyaltyTiers;
      if (!tiers) return;

      //Find our current and next tier objects
      this.current = tiers.find(function (tier) {
        return tier.id == _this2.currentTier;
      });
      if (!this.current) return console.warn('Failed to find current tier data.');
      this.next = tiers[this.current.position + 1];
      this.adjustCounts();

      //Update the tier display elements to show current and next
      var currentEl = this.progressTiers.find("".concat(LOYALTY_PROGRESS_TIER, "[").concat(LOYALTY_TIER_ID, "=\"").concat(this.current.id, "\"]"));
      if (!currentEl.length) return;
      currentEl.find(LOYALTY_TIER_NUMBER).html("[0".concat(this.current.position + 1, "]"));
      currentEl.find(LOYALTY_TIER_TITLE).html(this.current.name);
      currentEl.addClass("".concat(CLASS_VISIBLE, " ").concat(CLASS_CURRENT));

      //Current tier but no next == final tier
      if (!this.next) {
        this.container.addClass(CLASS_FINAL_TIER);
        return;
      }
      var nextEl = this.progressTiers.find("".concat(LOYALTY_PROGRESS_TIER, "[").concat(LOYALTY_TIER_ID, "=\"").concat(this.next.id, "\"]"));
      if (!nextEl.length) return;
      nextEl.find(LOYALTY_TIER_NUMBER).html("[0".concat(this.next.position + 1, "]"));
      nextEl.find(LOYALTY_TIER_TITLE).html(this.next.name);
      nextEl.addClass("".concat(CLASS_VISIBLE));
    }
  }, {
    key: "adjustCounts",
    value: function adjustCounts() {
      //Update the different count elements
      if (this.currentCount.length) this.currentCount.html(this.currentPoints);
      if (this.offset.length) this.offset.html(TREE_OFFSET * this.currentPoints);
      if (this.nextCount.length && this.next) {
        var remaining = this.next.bounds.lower - this.currentPoints;
        this.nextCount.html(remaining);
        this.nextContainer.addClass(CLASS_VISIBLE);

        //There's a next tier, so update the progress bar
        if (remaining) {
          var percent = (this.currentPoints - this.current.bounds.lower) / (this.current.bounds.upper + 1 - this.current.bounds.lower) * 100;
          if (percent > 100) percent = 100; //Just in case we try to go past this
          this.progressBar.css('width', "".concat(percent, "%"));
        } else {
          this.progressBar.css('width', '100%');
        }
      }
    }
  }, {
    key: "updateTextValues",
    value: function updateTextValues() {
      //Updating text to points
      this.container.find(LOYALTY_POINTS_TEXT).each(function (i, e) {
        var self = $(e);
        var text = self.find('.text');
        if (text.length) {
          var val = text.html();
          if (val == 'point') {
            text.html("".concat(Language.strings['loyalty.interface.point_name']));
          } else if (val == 'points') {
            text.html("".concat(Language.strings['loyalty.interface.points_name']));
          }
        }
      });

      //Show approved for our custom points 
      this.container.find(LOYALTY_HISTORY_STATUS).each(function (i, e) {
        var self = $(e);
        var span = self.find('span');
        if (span.length) {
          var val = span.html();
          if (val == '-') {
            span.html("".concat(Language.strings['loyalty.interface.approved_label']));
          }
        }
      });
      this.container.find(LOYALTY_HISTORY_ROW_CELL).each(function (i, e) {
        var self = $(e);
        if (self.html() == 'Transaction') {
          self.html("".concat(Language.strings['loyalty.interface.activity_label']));
        }
      });
    }
  }, {
    key: "onNavClick",
    value: function onNavClick(e) {
      e.preventDefault(e);
      e.stopPropagation(e);
      var self = $(e.currentTarget);
      var handle = self.attr(LOYALTY_NAVIGATION);
      if (!handle) return;
      var tab = this.container.find("[".concat(LOYALTY_TAB, "=\"").concat(handle, "\"]"));
      if (!tab.length) return; //Can't find the tab? Don't update
      this.navigationElements.removeClass(CLASS_ACTIVE);
      this.tabs.removeClass(CLASS_ACTIVE);
      tab.addClass(CLASS_ACTIVE);
      self.addClass(CLASS_ACTIVE);
    }
  }]);
  return LoyaltyInterface;
}();
$(document).ready($(CONTAINER_SELECTOR).each(function (i, e) {
  return new LoyaltyInterface($(e));
}));